import { render, staticRenderFns } from "./register-enamad.vue?vue&type=template&id=1b95ae7a&scoped=true&"
import script from "./register-enamad.vue?vue&type=script&lang=js&"
export * from "./register-enamad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b95ae7a",
  null
  
)

export default component.exports